import React from 'react';
import { Row } from 'reactstrap';
import DonutContainer from 'components/donut/DonutContainer';
import HorizontalBarChartContainer from 'components/horizontal-bar-chart/HorizontalBarChartContainer';
import CarouselContainer from 'components/carousel/CarouselContainer';
import TrendContainer from 'components/trends/TrendContainer';
import PlaneContainer from 'components/plane/PlaneContainer';

let page = 'live-tv';
let displayPageName = 'Live TV';

class LiveTVOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let showChannelRankings = true;
        let showCabinClassChannelOption = true;

        let dashboard = (
            <div>
                {showChannelRankings && (
                    <CarouselContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Live TV"
                        title="Channel Rankings"
                        workbenchTitle="titles"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />
                )}

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Live TV"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Program Rankings"
                        workbenchTitle="program-titles"
                        page={page}
                        pageName={displayPageName}
                        reportType="program-titles"
                        color="#7FCECD"
                        key="live_tv_overview_program_titles_1"
                        idx="live_tv_overview_program_titles_1"
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />

                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType="row"
                        forceReloadAll={this.props.forceReloadAll}
                        page={page}
                        pageName={displayPageName}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        allowedApps={this.props.allowedApps}
                        app={this.props.app}
                    />
                </Row>

                <TrendContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="Live TV"
                    forceReloadAll={this.props.forceReloadAll}
                    title="Trends"
                    workbenchTitle="trends"
                    page={page}
                    pageName={displayPageName}
                    key="live_tv_overview_trend_1"
                    id="live_tv_overview_trend_1"
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                />

                <PlaneContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="Live TV"
                    title="Cabin Class"
                    workbenchTitle="cabin_class_viewing"
                    page={page}
                    pageName={displayPageName}
                    forceReloadAll={this.props.forceReloadAll}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                    showChannelOption={showCabinClassChannelOption}
                />

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="Live TV"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Routes"
                        workbenchTitle="routes"
                        page={page}
                        pageName={displayPageName}
                        reportType="routes"
                        color="#F7A77F"
                        routes={true}
                        key="live_tv_overview_routes_1"
                        idx="live_tv_overview_routes_1"
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        app={this.props.app}
                    />
                </Row>
            </div>
        );

        return <div>{dashboard}</div>;
    }
}

export default LiveTVOverview;
